import React from "react";
import { PRIVACY, TERMS } from "../data/legal";
import { FadeIn, HexPattern, Eyebrow } from "../components/reactbits/Anim";

const LegalPage = ({ doc, testid }) => (
  <div className="bg-white text-[#1F1B13]" data-testid={testid}>
    <section className="relative overflow-hidden bg-[#FDFBF7] pt-40 pb-14">
      <HexPattern opacity={0.05} />
      <div className="relative mx-auto max-w-4xl px-6 lg:px-10">
        <Eyebrow>legal</Eyebrow>
        <h1 className="mt-6 font-heading text-4xl font-bold leading-tight sm:text-5xl" data-testid={`${testid}-heading`}>
          {doc.title}
        </h1>
        <p className="mt-4 text-sm font-semibold uppercase tracking-wider text-[#8A8272]">{doc.updated}</p>
      </div>
    </section>

    <section className="py-16">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <FadeIn>
          <p className="text-base leading-relaxed text-[#5D564A]">{doc.intro}</p>
        </FadeIn>
        <div className="mt-10 space-y-10">
          {doc.sections.map((s) => (
            <FadeIn key={s.h}>
              <h2 className="font-heading text-xl font-semibold text-[#1F1B13]">{s.h}</h2>
              {s.p.map((para, i) => (
                <p key={i} className="mt-3 text-[15px] leading-relaxed text-[#5D564A]">
                  {para}
                </p>
              ))}
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export const PrivacyPolicy = () => <LegalPage doc={PRIVACY} testid="privacy-page" />;
export const TermsOfUse = () => <LegalPage doc={TERMS} testid="terms-page" />;
